<template>
	<core-page>
		<div :class="containerClasses">
			<div class="omapi-modal omapi-modal__static content">
				<h2>You have reached the campaign limit for your account!</h2>
				<p>
					Get access to high-growth conversion features like Exit Intent® Technology, Campaign Scheduling,
					Countdown Timers and more with OptinMonster Pro!
				</p>

				<div class="omapi-templates__limit-exceeded__buttons">
					<core-upgrade-button
						size="large"
						color="green"
						:features="['unlimited-campaigns']"
						utm-medium="TemplateNoAccess"
					>
						Upgrade to Pro
					</core-upgrade-button>
					<br />
					<core-upgrade-button
						:features="['unlimited-campaigns']"
						:link-style="true"
						utm-medium="TemplateNoAccess"
					>
						Learn more about all Pro features
					</core-upgrade-button>
				</div>
			</div>
		</div>
	</core-page>
</template>
<script>
export default {
	props: {
		isPlaybooks: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		containerClasses() {
			return `omapi-templates__limit-exceeded${this.isPlaybooks ? ' is-playbook' : ''}`;
		},
	},
};
</script>
<style lang="scss">
.omapi-templates__limit-exceeded {
	background: url('../../assets/images/templates-limit-exceeded.png') center no-repeat;
	background-size: contain;
	min-height: 1850px;
	background-position: top center;

	&.is-playbook {
		background-image: url('../../assets/images/playbooks-limit-exceeded.png');
		background-size: 1200px;

		@media screen and (max-width: 1450px) {
			background-size: cover;
		}

		@media screen and (max-width: 1450px) {
			background-size: contain;
		}
	}

	.content {
		align-items: center;
		color: #646970;
		display: flex;
		flex-direction: column;
		text-align: center;

		h2 {
			font-size: 1.5em;
			font-weight: 700;
			margin: 5px 0 13px;
			letter-spacing: 0.2px;
		}

		p {
			margin-bottom: 25px;
		}

		.omapi-templates__limit-exceeded__buttons {
			.omapi-button__primary {
				margin-bottom: 20px;
				font-size: 16px;
				padding: 14px 20px;
			}
		}
	}
}
</style>
